import React from 'react';
import classnames from 'classnames';
import stylesheet from './Anchor.scss';

const Anchor = ({ theme, href, target, size, onClick, children }) => {
  const anchorClass = theme ? theme : '';
  const classes = classnames({
    'c-button': ![
      'inverse',
      'solid-volcano',
      'outline-teal',
      'solid-teal',
    ].includes(theme),
    'link-inverse': theme === 'inverse',
    'c-button--primary': theme === 'buttonPrimary',
    'c-button--secondary': theme === 'buttonSecondary',
    'c-button--tertiary': theme === 'buttonTertiary',
    [stylesheet[`anchor--${anchorClass}`]]: [
      'solid-volcano',
      'solid-teal',
      'outline-teal',
    ].includes(theme),
    'c-button--small': size === 'small',
    'c-button--large': size === 'large',
  });

  return (
    <a
      className={classes}
      href={href}
      onClick={onClick}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : null}
    >
      {children}
    </a>
  );
};

Anchor.defaultProps = {
  onClick: () => {},
};

export default Anchor;
